module.exports = __webpack_public_path__ + "img/title.38b1613f.svg";